var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6752 4.24134e-08H1.32367C0.592529 0.000366253 -0.000183063 0.593445 4.24134e-08 1.32477V22.6763C0.000366253 23.4075 0.593445 24.0002 1.32477 24H22.6752C23.4067 24.0002 23.9998 23.4073 24 22.6758C24 22.6756 24 22.6754 24 22.6752V1.32367C23.9996 0.592529 23.4066 -0.000183063 22.6752 4.24134e-08Z",
    fill: "#4267B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5703 24.0004V14.7192H19.6992L20.168 11.0864H16.5703V8.77264C16.5703 7.72327 16.8616 7.00824 18.3664 7.00824H20.2734V3.76782C19.9417 3.72369 18.8033 3.625 17.4787 3.625C14.7131 3.625 12.8203 5.3125 12.8203 8.41284V11.0864H9.70312V14.7192H12.8203V24.0004H16.5703Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.57476d0e.svg";
export { ForwardRef as ReactComponent };